import { seoOgTitle } from './SeoStore';

export const updateSeoOgTitle = (value) => seoOgTitle.update(oldValue => value);
